import { HOW_TO_STEPS } from '../../data/faq';

export default function HowItWorksSection() {
  return (
    <section className="py-16 sm:py-20" aria-labelledby="how-it-works-heading">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <h2
          id="how-it-works-heading"
          className="text-center text-2xl font-bold text-slate-900 sm:text-3xl"
        >
          How it works
        </h2>
        <ol className="mt-10 grid gap-8 md:grid-cols-3">
          {HOW_TO_STEPS.map((step, index) => (
            <li key={step.name} className="text-center">
              <span
                className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-indigo-600 text-lg font-bold text-white"
                aria-hidden
              >
                {index + 1}
              </span>
              <h3 className="mt-4 font-semibold text-slate-900">{step.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{step.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
